/**
 * Zopup - Subcriptions API
 * Zopup - Subcriptions API
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type VerificationStatus = 'Pending' | 'Verified' | 'Rejected' | 'Failed';

export const VerificationStatus = {
    Pending: 'Pending' as VerificationStatus,
    Verified: 'Verified' as VerificationStatus,
    Rejected: 'Rejected' as VerificationStatus,
    Failed: 'Failed' as VerificationStatus
};
